import { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import { ButtonProps } from 'antd/es/button';
import { CommonRefund, DisputeOperate } from 'services/api/return';
import DisputeModal from './DisputeModal';
import { InfoCircleFilled } from '@ant-design/icons';

interface Props extends Omit<ButtonProps, 'onClick'>, CommonRefund {
  internalStoreId: string;
  internalTradeId: string;
  onSuccess?: () => void;
  preDisputeContent?: string;
  failReasonCode?: number;
  region?: General.UpperCaseRegion;
}

/** 向Shopee争议; */
const DisputeToShopee = (props: Props) => {
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);
  const {
    internalStoreId,
    internalTradeId,
    externalStoreId,
    onSuccess,
    returnSn,
    externalTradeId,
    preDisputeContent,
    failReasonCode,
    region,
    ...btnProps
  } = props;
  const i18nKeyMap: Record<number, string> = {
    5001: '订单完成后发起的退单，不支持发起争议',
    5002: '当前退单状态不可发起争议',
    5003: 'Shopee官方服务出现异常，如有疑问请联系乐聊技术支持人员',
  };
  return (
    <div className="flex items-center">
      <Button size="small" {...btnProps} onClick={() => setVisible(true)}>
        {t('trade.向Shopee争议')}
      </Button>
      {!!failReasonCode && i18nKeyMap[failReasonCode] && (
        <Tooltip title={i18nKeyMap[failReasonCode]}>
          <InfoCircleFilled
            style={{
              color: 'var(--fett-surface-error-text)',
            }}
            className="ml-1 mb-[3px]"
          />
        </Tooltip>
      )}
      {visible && (
        <DisputeModal
          visible={visible}
          setVisible={setVisible}
          internalStoreId={internalStoreId}
          externalStoreId={externalStoreId}
          internalTradeId={internalTradeId}
          externalTradeId={externalTradeId}
          returnSn={returnSn}
          onSuccess={onSuccess}
          preDisputeContent={preDisputeContent}
          failReasonCode={failReasonCode}
          disputeOperate={DisputeOperate.向shopee争议}
          region={region}
        />
      )}
    </div>
  );
};

export default DisputeToShopee;
